<template>
    <div class="modal fade" id="dialogModal" tabindex="-1" aria-labelledby="dialogModalLabel" aria-hidden="false" ref="openDialogBtnRef">
        <div class="modal-dialog modal-md custom-modal-size  modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-6" id="dialogModalLabel">{{ modalSetting.modalNm }}</h1>
                </div>
                <div class="modal-body" :style="{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }">
                    <div class="datepicker-container">
                        <DatePicker ref="datePickerRef" v-model="dialogValue.selectDate" :format="'yyyy'" :year-picker="true" :inline="false" :selectDate="dialogValue.selectDate" @return="r=>dialogValue.selectDate = r"/>
                    </div>
                </div>
                <div class="modal-footer display">
                    <Message severity="error" v-if="dialogValue.isText">값을 입력해주세요.</Message>
                    <ElButton  type="modelFooterConfirm"  @buttonClick="confirm()">확인</ElButton>
                    <ElButton  type="modelFooterConfirm"  @buttonClick="closeModal()">닫기</ElButton>
                </div>
            </div>
        </div>
    </div>
</template>
   
<script setup>
import {ref,onMounted, reactive,defineEmits, onBeforeMount} from 'vue'
import Message from 'primevue/message';
import common from '@/js/common';
import DatePicker from '@/components/common/DatePicker.vue'


let dialog
const openDialogBtnRef = ref()
// Promise 객체를 핸들링하기 위한 ref
const resolvePromise = ref(null);


const modalSetting = ref({
    type : '',
    modalNm : '',
    msg : ''
})


const dialogValue = reactive({
    isText : false,
    inText : '',
    nowDate: null,
    selectDate:null
})


const emit = defineEmits(['updateValue','updateIndex']);

onMounted(()=>{
    dialog = new bootstrap.Modal(openDialogBtnRef.value,{
        keyboard: true
    });
})

onBeforeMount(()=>{
  dialogValue.nowDate = String(common.getThisYear());
  dialogValue.selectDate = dialogValue.nowDate
})
//dialog open
function openDialog(type,msg,titleMsg){
    switch(type) {
        case 'view':
            modalSetting.value.type = 'alert'
            modalSetting.value.modalNm = titleMsg
            modalSetting.value.msg = msg
            break;
        case 'confirm':
            modalSetting.value.type = 'confirm'
            modalSetting.value.modalNm = titleMsg
            // gridOption.value.value = msg
            break;
        case  'text':
            modalSetting.value.type = 'confirm'
            modalSetting.value.modalNm = titleMsg
            modalSetting.value.msg = msg
            break;
        default:
            modalSetting.value.type = 'dialog'
            modalSetting.value.modalNm = 'Dialog'
            modalSetting.value.msg = ''
            break;
    }
    dialog.show();
    // const {Promise,reject,resolve} = Promise.with
    return new Promise((resolve) => {
        resolvePromise.value = resolve;
    });
}


//모달창 닫기버튼 클릭
const cancel = ()=>{
    dialog.hide()
    emit('updateValue', dialogValue.inText);
    resolvePromise.value(false);
}

const checkvalue = () =>{
   return common.isEmpty(String(dialogValue.selectDate))
}

//모달창 확인버튼 클릭
const confirm = () => {
    if(!checkvalue()){
        emit('updateValue',dialogValue.selectDate);
        dialog.hide()
        resolvePromise.value(true);
    }else{
        dialogValue.isText = true
        setTimeout(() => {
            dialogValue.isText = false
        }, 2000);
    }
   
}

const closeModal = () =>{
    dialog.hide()
    resolvePromise.value(true);
}


defineExpose({
    openDialog,
})


</script>

<style>
.display {
    display: flex;
    align-items: center; /* 수직 정렬 */
    width: 100%; /* 부모 요소의 전체 너비 사용 */
}

.display > Message {
    flex-grow: 1; /* 남은 공간을 차지하여 왼쪽 끝으로 정렬 */
}

.display > ElButton {
    margin-left: auto; /* 오른쪽 끝으로 이동 */
}

.custom-modal-size {
  width: 600px; /* 원하는 너비 */
  max-width: 80%; /* 반응형 조정 */
  height: 500px; /* 원하는 높이 */
  max-height: 90%; /* 반응형 조정 */
}

.modal-content {
  height: 70%; /* 모달 내부 컨텐츠가 전체 높이를 차지하도록 설정 */
}
</style>
   